import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    infiniteScroll: Boolean,
    displayButton: Boolean,
    allLoaded: Boolean,
  };

  static targets = ['button', 'spinner'];

  connect() {
    this.isLoading = false;

    if (this.infiniteScrollValue) {
      this.checkInitialScroll();
    }
  }

  checkInitialScroll() {
    // Load projects once if window size does not allow to scroll because its height is too low
    if (document.documentElement.scrollHeight <= window.innerHeight) {
      this.loadProjects();
    }
  }

  checkScroll() {
    if (this.allLoadedValue || !this.infiniteScrollValue) {
      return;
    }

    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    if (scrollPosition >= pageHeight) {
      this.loadProjects();
    }
  }

  loadProjects() {
    if (!this.isLoading && !this.allLoadedValue) {
      this.toggleLoading(true);

      fetch(this.urlValue, {
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(response => response.text())
        .then(eval)
        .finally(() => this.toggleLoading(false));
    }
  }

  toggleLoading(loadingState) {
    this.isLoading = loadingState;

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.toggle('d-none', !loadingState);
    }

    if (this.hasButtonTarget && this.displayButtonValue) {
      this.buttonTarget.classList.toggle('d-none', loadingState);
    }
  }
}
